import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import Point from '../../../Utility/Point';
import TransformComponent from '../../../Component/Transform';
import { Easing, Tween } from '@tweenjs/tween.js';
import { delay } from '../../../Utility/Task/TaskQueue';
import { AwaitIterators } from '../AnimationHelper';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import { report } from '../../../report';
import Sprite from 'Prototype/Sprite';
import { PlaySound } from 'System/Audio/AudioHelper';

interface ISeasonPassPointsData {
    initialDelay: number;
    questIndex: number;
    icon: GameObject;
    onComplete: () => void;
}

export class SeasonPassPoints extends AnimationClip<ISeasonPassPointsData> {
    public *execute(animator: GameObject, meta: ISeasonPassPointsData): IterableIterator<number> {
        try {
            yield* delay(meta.initialDelay);

            animator.scene.emit(RenderSystemEvent.BRING_TO_FRONT, animator);

            // Create and show the booster sprite.
            const booster: GameObject = GameObject.Instantiate(Sprite, {
                texture: 'seasonpoints_icon_small',
                anchor: new Point(0.5, 0.5),
                scale: new Point(0.8, 0.8),
            });
            booster.getComponent(TransformComponent).position.set(meta.questIndex === -1 ? -75 : 25, meta.questIndex === -1 ? -30 : 115);
            animator.addChild(booster);

            PlaySound('trophy_collect');
            yield* this.moveBoosterToTarget(booster, meta.questIndex, 500);

            yield* this.scaleIcon(meta.icon);

            meta.onComplete();
        } catch (error) {
            report('SeasonPassPoints failed', { error, once: true });
        }
    }

    private *moveBoosterToTarget(booster: GameObject, questIndex: number, duration: number) {
        const boosterTransform: TransformComponent = booster.getComponent(TransformComponent);

        const tweenPosition: Tween = this.getTween(boosterTransform.position);
        const tweenScale: Tween = this.getTween(boosterTransform.scale);

        const toX = questIndex === -1 ? 715 : 320 - (questIndex * 300);
        const toY = questIndex === -1 ? -290 : -300;

        tweenPosition.to({ x: toX, y: toY }, duration).easing(Easing.Cubic.In);

        tweenScale
            .to({ x: 1.5, y: 1.5 }, duration)
            .easing(Easing.Cubic.In)
            .onComplete(() => booster.destroy());

        yield* AwaitIterators([this.startTween(tweenPosition), this.startTween(tweenScale)]);
    }

    private *scaleIcon(icon: GameObject) {
        const iconTransform: TransformComponent = icon.getComponent(TransformComponent);
        const startScale = iconTransform.scale.clone();
        const amplitude = 0.2;

        const tween: Tween = this.getTween(iconTransform.scale);
        yield* this.tweenTo(tween, startScale.x + amplitude);
        yield* this.tweenTo(tween, startScale.x);
    }

    private *tweenTo(
        tween: Tween,
        scale: number,
    ): IterableIterator<number> {
        tween.to({ x: scale, y: scale }, 100);
        yield* this.startTween(tween);
    }
}
